import { Controller } from '@hotwired/stimulus';
import { post } from '@rails/request.js';
import { debounce, isEmpty } from 'lodash';

// Connects to data-controller="pitch-agency-creators-step"
export default class extends Controller {
  static targets = [
    'selectCreator',
    'submitButton',
    'selectedCreatorCounter',
    'keywordInput',
    'searchClear'
  ];

  searchformSubmitDebounceFunc = null;
  clearDebounceFunc = null;
  keywords = null;

  connect() {
    if (this.getAllEnabledCreatorCheckboxes() > 0) {
      if (this.hasSubmitButtonTarget) {
        this.submitButtonTarget.classList.remove('disabled');
        this.selectedCreatorCounterTarget.innerText = `${this.getAllEnabledCreatorCheckboxes()} Creators Selected`;
      }
    } else {
      if (this.hasSubmitButtonTarget) {
        this.submitButtonTarget.classList.add('disabled');
        this.selectedCreatorCounterTarget.innerText = '0 Creators Selected';
      }
    }
    this.init();
  }

  init() {
    this.searchformSubmitDebounceFunc = debounce(() => {
      post('/user/agencies/creators/search', {
        body: {
          keywords: this.keywords || '',
          opportunity_id: this.keywordInputTarget?.dataset?.opportunityId
        },
        responseKind: 'turbo-stream'
      });
    }, 300);

    this.clearDebounceFunc = debounce(() => {
      if (this.hasSearchClearTarget) {
        this.searchClearTarget.classList.add('d-none');
      }
      this.keywordInputTarget.value = '';
    }, 400);
  }

  getAllEnabledCreatorCheckboxes() {
    const checkboxes = document.querySelectorAll(
      'input[type="checkbox"][name="pitch[agency_creator_ids][]"]'
    );
    let enabledCheckboxesCount = 0;

    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        enabledCheckboxesCount++;
      }
    });

    return enabledCheckboxesCount;
  }

  enableSubmitIfCreatorSelected() {
    if (this.hasSelectCreatorTarget) {
      const selectedCreatorCount = this.getAllEnabledCreatorCheckboxes();
      if (selectedCreatorCount > 0) {
        this.submitButtonTarget.classList.remove('disabled');
        this.selectedCreatorCounterTarget.innerText = `${this.getAllEnabledCreatorCheckboxes()} Creators Selected`;
      } else {
        this.submitButtonTarget.classList.add('disabled');
        this.selectedCreatorCounterTarget.innerText = '0 Creators Selected';
      }
    }
  }

  handleKeyup() {
    if (this.hasSearchClearTarget) {
      if (isEmpty(this.keywordInputTarget.value)) {
        this.searchClearTarget.classList.add('d-none');
      } else {
        this.searchClearTarget.classList.remove('d-none');
      }
    }

    this.keywords = this.keywordInputTarget.value;
    this.searchformSubmitDebounceFunc();
  }

  clearSearchInput() {
    this.keywords = '';
    this.searchformSubmitDebounceFunc();
    this.clearDebounceFunc();
  }

  handleKeydown(event) {
    if (event.key === 'Enter') event.preventDefault();
  }
}
